import { render } from "./ProductPricingSection.vue?vue&type=template&id=03abfea0"
import script from "./ProductPricingSection.vue?vue&type=script&lang=js"
export * from "./ProductPricingSection.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__